import { render } from "./SettingsPage.vue?vue&type=template&id=3b4cc18c&ts=true"
import script from "./SettingsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SettingsPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SettingsPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b4cc18c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b4cc18c', __exports__)) {
    api.reload('3b4cc18c', __exports__)
  }
  
  module.hot.accept("./SettingsPage.vue?vue&type=template&id=3b4cc18c&ts=true", () => {
    api.rerender('3b4cc18c', render)
  })

}


export default __exports__